import React from 'react'
import { ObjectDetailsWrapperProps } from '../ObjectDetails'
import { FloorNumber } from '../fields/floorNumber/FloorNumber'
import { TotalFloors } from '../fields/totalFloors/TotalFloors'
import HeatingTypeField from '../../commonFields/heatingType/HeatingTypeField'
import ConstructionConditionField from '../../construction/fields/constructionConditionField/ConstructionConditionField'

export const floorNumberField =
  (wrapperClassName?: string, labelTranslationKey?: string, showMandatory = false) =>
  (props: ObjectDetailsWrapperProps) => (
    <FloorNumber
      {...props}
      wrapperClassName={wrapperClassName}
      labelTranslationKey={labelTranslationKey}
      showMandatory={showMandatory}
    />
  )

export const totalFloorsField =
  (wrapperClassName?: string, labelTranslationKey?: string, showMandatory = false) =>
  (props: ObjectDetailsWrapperProps) => (
    <TotalFloors
      {...props}
      wrapperClassName={wrapperClassName}
      labelTranslationKey={labelTranslationKey}
      showMandatory={showMandatory}
    />
  )

export const objectConditionField = (wrapperClassName?: string) => (props: ObjectDetailsWrapperProps) => (
  <ConstructionConditionField {...props} additionalClassNames={wrapperClassName} />
)

export const heatingTypeField = (wrapperClassName?: string) => (props: ObjectDetailsWrapperProps) => (
  <HeatingTypeField {...props} wrapperClassName={wrapperClassName} />
)
